import { useEffect } from 'react'

export const SubotCss = () => {
  useEffect(() => {
    setTimeout(() => {
      // @ts-ignore
      import('react-phone-number-input/style.css')
    }, 1000)
  }, [])
  return null
}
